/**
 * @generated SignedSource<<7793a0d7b39a95ccc218ad888bf0227b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateReportWorkflowWorkspaceStepByIdInput = {
  clientMutationId?: string | null;
  id: string;
  patch: ReportWorkflowWorkspaceStepPatch;
};
export type ReportWorkflowWorkspaceStepPatch = {
  createdAt?: any | null;
  deletedAt?: any | null;
  description?: string | null;
  key?: string | null;
  name?: string | null;
  reportWorkflowWorkspaceId?: any | null;
  rowId?: any | null;
  sections?: any | null;
  status?: string | null;
  stepOrder?: number | null;
  updatedAt?: any | null;
};
export type useWorkflowStepUpdateMutation$variables = {
  input: UpdateReportWorkflowWorkspaceStepByIdInput;
};
export type useWorkflowStepUpdateMutation$data = {
  readonly updateReportWorkflowWorkspaceStepById: {
    readonly reportWorkflowWorkspaceStep: {
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceStep_reportWorkflowWorkspaceStep" | "StepHeader_reportWorkflowWorkspaceStep">;
    } | null;
    readonly reportWorkflowWorkspace: {
      readonly report: {
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceHeader_report">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkflowWorkspace_reportWorkflowWorkspace">;
    } | null;
  } | null;
};
export type useWorkflowStepUpdateMutation = {
  variables: useWorkflowStepUpdateMutation$variables;
  response: useWorkflowStepUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepOrder",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sections",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workspaceOrder",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "STEP_ORDER_ASC"
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "WORKSPACE_ORDER_ASC"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkflowStepUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateReportWorkflowWorkspaceStepPayload",
        "kind": "LinkedField",
        "name": "updateReportWorkflowWorkspaceStepById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportWorkflowWorkspaceStep",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspaceStep",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceStep_reportWorkflowWorkspaceStep"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StepHeader_reportWorkflowWorkspaceStep"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportWorkflowWorkspace",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspace",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkflowWorkspace_reportWorkflowWorkspace"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Report",
                "kind": "LinkedField",
                "name": "report",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceHeader_report"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkflowStepUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateReportWorkflowWorkspaceStepPayload",
        "kind": "LinkedField",
        "name": "updateReportWorkflowWorkspaceStepById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportWorkflowWorkspaceStep",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspaceStep",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportWorkflowWorkspace",
                "kind": "LinkedField",
                "name": "reportWorkflowWorkspace",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                    "kind": "LinkedField",
                    "name": "reportWorkflowWorkspaceSteps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportWorkflowWorkspaceStep",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Report",
                    "kind": "LinkedField",
                    "name": "report",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "ReportWorkflowWorkspacesConnection",
                        "kind": "LinkedField",
                        "name": "reportWorkflowWorkspaces",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReportWorkflowWorkspace",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": (v10/*: any*/),
                                "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                                "kind": "LinkedField",
                                "name": "reportWorkflowWorkspaceSteps",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReportWorkflowWorkspaceStep",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v7/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "reportWorkflowWorkspaces(orderBy:\"WORKSPACE_ORDER_ASC\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportWorkflowWorkspace",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspace",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                "kind": "LinkedField",
                "name": "reportWorkflowWorkspaceSteps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportWorkflowWorkspaceStep",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Report",
                "kind": "LinkedField",
                "name": "report",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "config",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reviewStatus",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "ReportWorkflowWorkspacesConnection",
                    "kind": "LinkedField",
                    "name": "reportWorkflowWorkspaces",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportWorkflowWorkspace",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": (v10/*: any*/),
                            "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                            "kind": "LinkedField",
                            "name": "reportWorkflowWorkspaceSteps",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReportWorkflowWorkspaceStep",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportWorkflowWorkspaces(orderBy:\"WORKSPACE_ORDER_ASC\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportUserFilesConnection",
                    "kind": "LinkedField",
                    "name": "reportUserFiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportUserFile",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserFile",
                            "kind": "LinkedField",
                            "name": "userFile",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "pendingResolutions",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "condition",
                        "value": {
                          "updateStatus": "pending"
                        }
                      }
                    ],
                    "concreteType": "ReportResolutionsConnection",
                    "kind": "LinkedField",
                    "name": "reportResolutions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "940c2bc28b732a82d28e2e7af1b3dc15",
    "id": null,
    "metadata": {},
    "name": "useWorkflowStepUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkflowStepUpdateMutation(\n  $input: UpdateReportWorkflowWorkspaceStepByIdInput!\n) {\n  updateReportWorkflowWorkspaceStepById(input: $input) {\n    reportWorkflowWorkspaceStep {\n      ...WorkspaceStep_reportWorkflowWorkspaceStep\n      ...StepHeader_reportWorkflowWorkspaceStep\n      id\n    }\n    reportWorkflowWorkspace {\n      ...WorkflowWorkspace_reportWorkflowWorkspace\n      report {\n        ...WorkspaceHeader_report\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment StepHeader_reportWorkflowWorkspaceStep on ReportWorkflowWorkspaceStep {\n  id\n  stepOrder\n  status\n  key\n  reportWorkflowWorkspace {\n    id\n    workspaceOrder\n    reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n      nodes {\n        id\n        key\n        name\n        stepOrder\n      }\n    }\n    report {\n      id\n      reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n        nodes {\n          id\n          workspaceOrder\n          reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n            nodes {\n              id\n              status\n              stepOrder\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment WorkflowWorkspace_reportWorkflowWorkspace on ReportWorkflowWorkspace {\n  key\n  name\n  reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n    nodes {\n      name\n      status\n      ...WorkspaceStep_reportWorkflowWorkspaceStep\n      id\n    }\n  }\n  report {\n    rowId\n    id\n  }\n}\n\nfragment WorkspaceHeader_report on Report {\n  id\n  name\n  config\n  reviewStatus\n  status\n  reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n    nodes {\n      id\n      name\n      key\n      reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n        nodes {\n          id\n          status\n          sections\n        }\n      }\n    }\n  }\n  reportUserFiles {\n    nodes {\n      type\n      userFile {\n        id\n        rowId\n        kind\n        name\n        key\n      }\n      id\n    }\n  }\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n}\n\nfragment WorkspaceStep_reportWorkflowWorkspaceStep on ReportWorkflowWorkspaceStep {\n  id\n  key\n  name\n  stepOrder\n  sections\n  status\n  description\n}\n"
  }
};
})();

(node as any).hash = "98b30b404e9b58f1b394242bd4c5e9a9";

export default node;
